export enum PREDIGGO_ITEM_TYPE {
    PRODUCT = 'PRODUCT',
    ARTICLE ='CMS',
    RECIPE = 'CONTENT_1'
}